// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const baseUri = "/api/mcmc/lineCard";

interface BrandModel {
    id: string;
    name: string;
    detailPagePath: string;
    logoAltText: string;
    logoLargeImagePath: string;
    logoSmallImagePath: string;
}

interface BrandCategoriesModel {
    name: string;
    url: string;
    brands: BrandModel[];
}

export interface BrandCategoriesCollection extends BaseModel {
    categoriesCollection: BrandCategoriesModel[];
}

export async function getBrandCategories() {
    const categories = await get<BrandCategoriesCollection>(`${baseUri}/categories`);
    return categories;
}

interface BrandSolutionsModel {
    displayName: string;
    value: string;
}

export interface BrandSolutionsCollection extends BaseModel {
    solutionsCollection: BrandSolutionsModel[];
}

export async function getBrandSolutions() {
    const solutions = await get<BrandSolutionsCollection>(`${baseUri}/solutions`);
    return solutions;
}

export interface SolutionParametersModel {
    sort: string;
    select: string;
    pageSize: number;
    page: number;
    solution: string;
}

export interface ShareBrandViaEmailApiParameter extends ApiParameter, SolutionParametersModel {
    toEmail: string;
}

export async function shareBrandViaEmailApi(parameter: ShareBrandViaEmailApiParameter) {
    const parameterStr = Object.keys(parameter)
        .map(function (key) {
            return `${key}=${(parameter as any)[key]}`;
        })
        .join("&");

    const results = await post<ShareBrandViaEmailApiParameter>(`${baseUri}/emailPdf?${parameterStr}`);
    return results;
}
